module.exports = __webpack_public_path__ + "img/cs.8972c3da.png";